<div class="modal-header">
  <h4 class="modal-title h5" translate>Update Gateways</h4>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ul class="list-group mb-2">
    @for (gateway of updatableGateways; track gateway) {
      <li class="list-group-item">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="check{{gateway.id}}" [(ngModel)]="gateway.selected">
          <label class="form-check-label" for="check{{gateway.id}}">
            <span [innerText]="gateway.id"> </span>
            <span [innerText]="gateway.name"> </span>
            <span [innerText]="gateway.machineName"> </span>
            <span [innerText]="gateway.tenantName"> </span>
          </label>
        </div>
      </li>
    }
  </ul>

  <div class="alert alert-info" translate>
    Please notice that you only see the updatable gateways that were visible on the current table view. Gateways hidden
    by pagination will not be considered.
  </div>
</div>

<div class="modal-footer">
  <div class="modal-footer-inner">
    <div class="row align-items-center flex-fill">
      <div class="col"></div>
      <div class="col-auto">
        <button type="button" class="btn btn-outline-primary mr-2" (click)="onCancel()">
          <span translate>Cancel</span>
        </button>
        <button type="button" class="btn btn-primary"
          [disabled]="isUpdateButtonDisabled()"
          (click)="update()">
          <span translate>Update</span>
        </button>
      </div>
    </div>
  </div>
</div>
